import { TApplicationState } from '../../types/redux';

export const selectSeo = (state: TApplicationState) => {
  return state.catalog.seo;
};
